import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpHeadersHelperService } from '@core/_services/http-headers-helper.service'
import { environment } from '@env';
import { WallSetter } from '../_models/wall-setter';

@Injectable({
  providedIn: 'root'
})
export class WallSetterService {

  private apiUrl: string = `${environment.apiUrl}`;
  private endPoint: string = '/Walls';
  private headers: HttpHeaders = this.httpHeadersHelperService.getCustomHeaders();

  Set(wallSetter: WallSetter) {
    return this.http.post(this.apiUrl + this.endPoint + '/SetNewContentForWall', wallSetter, { headers: this.headers });
  }

  constructor(private http: HttpClient,
    private httpHeadersHelperService: HttpHeadersHelperService) {
  }
}
